import React from 'react'
import { css, SerializedStyles } from '@emotion/core'
import { FrontTabletButton } from '@/components/molecules/front-tablet/button'
import { ButtonType } from '@/components/atoms/button'
import { createSelfCheckinResponsiveStyle } from '@/utils/front-tablet-responsive-style'

type IdentityDocumentCaptureType = 'license' | 'passport'

type Props = {
  type: IdentityDocumentCaptureType
  image: string | undefined
  sampleImage: string | undefined
  label: string
  onCapture: () => void
}

export const IdentityDocumentCaptureItem: React.FC<Props> = ({ type, image, sampleImage, label, onCapture }) => (
  <div css={captureItemStyle}>
    <div css={imageContainerStyle}>
      <img css={[imageStyle, imageAspectRatioStyles[type]]} src={image ?? sampleImage} alt={label} />
      {image && (
        <img
          css={[capturedCheckStyle, capturedCheckSizeStyles[type]]}
          src={require('@/static/images/self-checkin/icon_captured_check.svg')}
          alt=""
        />
      )}
    </div>
    <FrontTabletButton buttonType={ButtonType.Secondary} width="100%" height={60} customCss={captureButtonStyle} onClick={onCapture}>
      <img src={require('@/static/images/camera_icon_orange.svg')} alt="" />
      {label}
    </FrontTabletButton>
  </div>
)

const captureItemStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
  minWidth: 0,
})

const imageContainerStyle = css({
  position: 'relative',
})

const imageStyle = css({
  display: 'block',
  width: '100%',
  objectFit: 'cover',
  borderRadius: 10,
})

const imageAspectRatioStyles: Record<IdentityDocumentCaptureType, SerializedStyles> = {
  license: css({ aspectRatio: '470 / 294' }),
  passport: css({ aspectRatio: '295 / 205' }),
}

const capturedCheckStyle = css({
  position: 'absolute',
})

const capturedCheckSizeStyles: Record<IdentityDocumentCaptureType, SerializedStyles> = {
  license: css({ top: -20, right: -20, width: 60, height: 60 }),
  passport: css(
    { top: -15, right: -15, width: 50, height: 50 },
    createSelfCheckinResponsiveStyle({
      landscape13: { top: -20, right: -20, width: 60, height: 60 },
    }),
  ),
}

const captureButtonStyle = css(
  {
    gap: 12,
    fontSize: 22,
    fontWeight: 'bold',
    img: { width: 24 },
  },
  createSelfCheckinResponsiveStyle({
    landscape13: { height: 66, fontSize: 26, img: { width: 32 } },
  }),
)
